import { render, staticRenderFns } from "./RoleGrid.vue?vue&type=template&id=6224587d&scoped=true&"
import script from "./RoleGrid.vue?vue&type=script&lang=js&"
export * from "./RoleGrid.vue?vue&type=script&lang=js&"
import style0 from "./RoleGrid.vue?vue&type=style&index=0&id=6224587d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224587d",
  null
  
)

export default component.exports